import React from 'react';
import TableRow from './TableRow';

const TableBody = ({ terminals }) => {
    const rows = terminals.map(terminal => <TableRow key={terminal.id} {...terminal} />);
    return <tbody>{rows}</tbody>;
};

export default TableBody;


// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/TableBody.js